import script from "./AddInsurancePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddInsurancePage.vue?vue&type=script&setup=true&lang=ts"

import "./AddInsurancePage.vue?vue&type=style&index=0&id=04a51562&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a51562"]])

export default __exports__